(function () {
  // Define our constructor
  this.GDPRman = function () {
    var cookietable = [
      {
        nome: "ck_consent",
        dominio: "local",
        scadenza: "1y",
        tipo: "HTTP cookie",
        famiglia: "Necessari",
        descrizione:
          "Memorizza lo stato del consenso ai cookie dell'utente per il dominio corrente",
      },
      {
        nome: "PHPSESSID",
        dominio: "local",
        scadenza: "Session",
        tipo: "HTTP cookie",
        famiglia: "Necessari",
        descrizione:
          "Preserva gli stati dell'utente nelle diverse pagine del sito.",
      },
      {
        nome: "_ga",
        dominio: "local",
        scadenza: "2y",
        tipo: "HTTP cookie",
        famiglia: "Statistici",
        descrizione:
          "Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.",
      },
      {
        nome: "_gat",
        dominio: "local",
        scadenza: "Session",
        tipo: "HTTP cookie",
        famiglia: "Statistici",
        descrizione:
          "Utilizzato da Google Analytics per limitare la frequenza delle richieste",
      },
      {
        nome: "_gid",
        dominio: "local",
        scadenza: "1d",
        tipo: "HTTP cookie",
        famiglia: "Statistici",
        descrizione:
          "Registra un ID univoco utilizzato per generare dati statistici su come il visitatore utilizza il sito internet.",
      },
      {
        nome: "collect",
        dominio: "google-analytics.com",
        scadenza: "Session",
        tipo: "Pixel tracker",
        famiglia: "Statistici",
        descrizione:
          "Usato per inviare dati al sistema Google Analytics relativi al dispositivo e al comportamento dell'utente. Traccia l'utente attraverso i suoi dispositivi e canali di comunicazione",
      },
      {
        nome: "aet-dismiss",
        dominio: "disqus.com",
        scadenza: "Persistent",
        tipo: "HTML local storage",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "drafts.queue",
        dominio: "disqus.com",
        scadenza: "Persistent",
        tipo: "HTML local storage",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "fr",
        dominio: "facebook.com",
        scadenza: "3m",
        tipo: "HTTP cookie",
        famiglia: "Marketing",
        descrizione:
          "Utilizzato da Facebook per fornire una serie di prodotti pubblicitari come offerte in tempo reale da inserzionisti terzi.",
      },
      {
        nome: "juggler/event.gif",
        dominio: "disqus.com",
        scadenza: "Session",
        tipo: "Pixel tracker",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "NID",
        dominio: "google.com",
        scadenza: "6m",
        tipo: "HTTP cookie",
        famiglia: "Marketing",
        descrizione:
          "Registra un ID univoco che identifica il dispositivo dell'utente che ritorna sul sito. L'ID viene utilizzato per pubblicit&agrave; mirate.",
      },
      {
        nome: "r/collect",
        dominio: "doubleclick.net",
        scadenza: "Session",
        tipo: "Pixel tracker",
        famiglia: "Marketing",
        descrizione: "Utilizzato per eventuali operazioni di remarketing",
      },
      {
        nome: "submitted_posts_cache",
        dominio: "disqus.com",
        scadenza: "Persistent",
        tipo: "HTML local storage",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "tr",
        dominio: "facebook.com",
        scadenza: "Session",
        tipo: "Pixel tracker",
        famiglia: "Marketing",
        descrizione:
          "Utilizzato da Facebook per fornire una serie di prodotti pubblicitari come offerte in tempo reale da inserzionisti terzi.",
      },
      {
        nome: "vglnk.Agent.p",
        dominio: "disqus.com",
        scadenza: "1y",
        tipo: "HTTP cookie",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "vglnk.PartnerRfsh.p",
        dominio: "disqus.com",
        scadenza: "1y",
        tipo: "HTTP cookie",
        famiglia: "Marketing",
        descrizione:
          "Traccia l'attivit&agrave; di interazione dell'utente con alcuni contenuti del sito",
      },
      {
        nome: "_fbp",
        dominio: "local",
        scadenza: "90d",
        tipo: "HTTP cookie",
        famiglia: "Statistici",
        descrizione:
          "Utilizzato da Facebook per tracciare il comportamento dell'utente.",
      },
      {
        nome: "_fbc",
        dominio: "local",
        scadenza: "90d",
        tipo: "HTTP cookie",
        famiglia: "Statistici",
        descrizione:
          "Utilizzato da Facebook per tracciare il comportamento dell'utente.",
      },
    ];

    // Default settings
    var defaults = {
      noPreset: false,
      mass_accept: true,
      noFirstClick: false,
      noScroll: false,
      privacyTableContiner: "#privacy-table",
      banner_container: "body",
      c_status: false,
      callbackBefore: function () {},
      callbackAfter: function () {},
    };

    // Create options by extending defaults with the passed in arugments
    if (arguments[1] && typeof arguments[1] === "object") {
      this.options = extendDefaults(defaults, arguments[1]);
    } else {
      this.options = defaults;
    }

    // Create global element references
    this.b = arguments[0];
    this.ck_accept = 0;
    this.cookieBannerId = "ck_banner";
    this.cookieCustomizerId = "cookieCustomizer";
    this.c_status = this.options.c_status;

    this.getParameters = gets();
    let banner = this.b.banner.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    // banner += " " + this.b.banner2.replace(/</g, "&lt;").replace(/>/g, "&gt;");
    // banner += " " + this.b.banner3.replace(/</g, "&lt;").replace(/>/g, "&gt;");

    this.bannerConfiguration = {
      titolo: this.b.titolo,
      banner: banner,
      btn: {
        accetta: this.b.accetta,
        rifiuta: this.b.rifiuta,
        personalizza: this.b.personalizza,
        accettaCustomizer: this.b.accettaCustomizer,
      },
      customizePanel: {
        title: this.b.customizePanelTitle,
        description: this.b.customizePanelDescription,
      },
      consents: [
        {
          id: "ck_necessari",
          checked: "checked",
          disabled: "disabled",
          title: this.b.necessari.title,
          description: this.b.necessari.text,
        },
        // {
        //   id: "ck_tecnici",
        //   dataIndex: "0",
        //   checked: "",
        //   disabled: "",
        //   title: "Tecnici",
        //   description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500 tecnici",
        // },
        {
          id: "ck_statistici",
          dataIndex: "1",
          checked: "",
          disabled: "",
          title: this.b.analitici.title,
          description: this.b.analitici.text,
        },
        {
          id: "ck_marketing",
          dataIndex: "2",
          checked: "",
          disabled: "",
          title: this.b.marketing.title,
          description: this.b.marketing.text,
        },
        // {
        //   id: "ck_profilazione",
        //   dataIndex: "3",
        //   checked: "",
        //   disabled: "",
        //   title: "Cookie di profilazione",
        //   description: "Questi cookie creano profili personalizzati relativi all'utente per finalità pubblicitarie.",
        // },
      ],
    };

    for (k in Object.keys(this.bannerConfiguration.consents)) {
      let consentId = this.bannerConfiguration.consents[k].dataIndex;

      // TODO Allineare con il cookie di Shopify
      if (this.c !== null) {
        if (this.c && this.c.inArray(consentId)) {
          this.bannerConfiguration.consents[k].checked = "checked";
        }
      } else {
        // il cookie non c'è, vado di preset
        this.bannerConfiguration.consents[k].checked = "";
      }
    }

    if (typeof Element.prototype.remove == "undefined") {
      Element.prototype.remove = function () {
        this.parentElement.removeChild(this);
      };
    }

    if (typeof NodeList.prototype.remove == "undefined") {
      NodeList.prototype.remove = HTMLCollection.prototype.remove =
        function () {
          for (var i = this.length - 1; i >= 0; i--) {
            if (this[i] && this[i].parentElement) {
              this[i].parentElement.removeChild(this[i]);
            }
          }
        };
    }

    // event binding

    if (
      this.getParameters.hasOwnProperty("destination") &&
      this.getParameters.destination != "" &&
      document.getElementById(this.getParameters.destination) != null
    ) {
      this.options.banner_container = "#" + this.getParameters.destination;
    }

    if (!this.c_status) {
      debb("show banner");
    } else {
      // activate_elements.call(this);
    }

    this.privacyTable = document.querySelector(
      this.options.privacyTableContiner
    );
    if (this.privacyTable != null) {
      var html =
        "<p>" +
        this.b.declaration +
        "</p>" +
        '<div class="table-responsive mt-3">' +
        '<table class="table" border="1" id="htmlCookieTable">' +
        "<thead>" +
        "<tr>" +
        "<th>" +
        this.b.nome +
        "</th>" +
        "<th>" +
        this.b.dominio +
        "</th>" +
        "<th>" +
        this.b.scadenza +
        "</th>" +
        "<th>" +
        this.b.tipo +
        "</th>" +
        "<th>" +
        this.b.famiglia +
        "</th>" +
        "<th>" +
        this.b.descrizione +
        "</th>" +
        "</tr>" +
        "</thead>" +
        "<tbody>";

      for (i = 0; i < cookietable.length; i++) {
        html +=
          "<tr>" +
          "<td>" +
          cookietable[i].nome +
          "</td>" +
          "<td>" +
          cookietable[i].dominio +
          "</td>" +
          "<td>" +
          cookietable[i].scadenza +
          "</td>" +
          "<td>" +
          cookietable[i].tipo +
          "</td>" +
          "<td>" +
          cookietable[i].famiglia +
          "</td>" +
          "<td>" +
          cookietable[i].descrizione +
          "</td>" +
          "</tr>";
      }

      html +=
        "</tbody>" +
        "</table>" +
        "</div>" +
        '<p><span id="modificaConsenso">' +
        this.b.modifica +
        '</span> - <span id="eliminaConsensi"">' +
        this.b.elimina +
        "</span></p>";

      this.privacyTable.innerHTML = html;

      let _ = this;
      this.privacyTable
        .querySelector("#eliminaConsensi")
        .addEventListener("click", function () {
          delete_cookie("ck_consent");
        });
    }
  };

  GDPRman.prototype.showBanner = function (reload = false) {
    let _ = this;

    let bannerNode = document.createElement("div");
    bannerNode.id = this.cookieBannerId;
    let cookieBannerTemplate = this.getBanner();

    document
      .querySelector(this.options.banner_container)
      .appendChild(cookieBannerTemplate);

    let modalNode = document.createElement("div");
    modalNode.id = this.cookieCustomizerId;

    let cookieBannerCustomizerTemplate = this.getBannerCustomizer();

    document.querySelector("body").appendChild(cookieBannerCustomizerTemplate);

    document
      .getElementById("ck_accetta")
      .addEventListener("click", function () {
        accetta.call(_, reload);
      });
    document.getElementById("ck_close").addEventListener("click", function () {
      rifiuta.call(_, reload);
    });
    document
      .getElementById("ck_close_x")
      .addEventListener("click", function () {
        rifiuta.call(_, reload);
      });
    document
      .getElementById("ck_accetta_tutti")
      .addEventListener("click", function () {
        accettaTutti.call(_, reload);
      });

    document
      .getElementById("ck_cookieCustomizer_close")
      .addEventListener("click", function () {
        document.getElementById("cookieCustomizer").classList.remove("show");
      });
    document
      .getElementById("ck_customize")
      .addEventListener("click", function () {
        document.getElementById("cookieCustomizer").classList.add("show");
      });
    // esclude il click sul banner per accettare
    if (typeof document.getElementById("ck_banner") !== "undefined") {
      document
        .getElementById("ck_banner")
        .addEventListener("click", function (event) {
          event.stopPropagation();
          //console.log("prevented");
        });
    }
  };

  GDPRman.prototype.isAllowed = function (elem, ck_consent) {
    debb("##");
    debb(elem);
    debb(ck_consent);
    debb("--");
    var res = true;
    var c = elem.dataset.ckconsent.split(",");
    for (k = 0; k < c.length; k++) {
      debb("TEST " + k + ": " + ck_consent[c[k]]);
      if (!ck_consent[c[k]]) res = false;
    }
    return res;
  };
  GDPRman.prototype.getAcceptedCookies = function () {
    let settedCookies = [];
    if (document.cookie.includes("ck_consent")) {
      let cookies = document.cookie.split("; "),
        c;
      for (i in cookies) {
        c = cookies[i];
        if (c.includes("ck_consent")) {
          let parts = c.split("=");
          settedCookies = parts[1].split(",");
          break;
        }
      }
    }
    return settedCookies;
  };
  GDPRman.prototype.getConsents = function () {
    return this.bannerConfiguration.consents;
  };
  //
  // Private Methods
  //

  GDPRman.prototype.getBanner = function () {
    let parser = new DOMParser();
    let bannerDescription = parser.parseFromString(
      this.bannerConfiguration.banner,
      "text/html"
    ).body.textContent;

    // Creazione dell'HTML
    let ckBanner = document.createElement("div");
    ckBanner.id = "ck_banner";

    let container = document.createElement("div");
    container.className = "container-fluid";
    ckBanner.appendChild(container);

    let bRow = document.createElement("div");
    bRow.className = "row justify-content-center";
    container.appendChild(bRow);

    let bCol12 = document.createElement("div");
    bCol12.className = "col-12";
    bRow.appendChild(bCol12);

    let closeSpan = document.createElement("span");
    closeSpan.id = "ck_close_x";
    bCol12.appendChild(closeSpan);

    let innerRow = document.createElement("div");
    innerRow.className = "row";
    bCol12.appendChild(innerRow);

    let innerCol12 = document.createElement("div");
    innerCol12.className = "col-12";
    innerRow.appendChild(innerCol12);

    let flexDiv = document.createElement("div");
    flexDiv.className = "d-flex flex-wrap align-items-center";
    innerCol12.appendChild(flexDiv);

    let leftCol = document.createElement("div");
    leftCol.className = "col-12 col-lg-8 col-xl-9 px-0";
    flexDiv.appendChild(leftCol);

    let titleSpan = document.createElement("span");
    titleSpan.className = "titleLev4 colorBlack";
    titleSpan.textContent = this.bannerConfiguration.titolo;
    leftCol.appendChild(titleSpan);

    let textSection = document.createElement("section");
    textSection.className = "textContainer";
    leftCol.appendChild(textSection);

    let p = document.createElement("p");
    p.className = "smallParagraph mt-3";
    p.innerHTML = bannerDescription; // Usiamo innerHTML perché il testo potrebbe contenere HTML (come <strong> e <a>)
    textSection.appendChild(p);

    let rightCol = document.createElement("div");
    rightCol.className =
      "col-12 col-lg-3 col-xxl-2 offset-xxl-1 px-0 mt-3 mt-lg-0 d-md-flex align-items-center d-lg-block flex-wrap";
    flexDiv.appendChild(rightCol);

    let createCustomBtn = (id, text) => {
      let btn = document.createElement("span");
      btn.id = id;
      btn.className = "customBtn style1 mb-3 w-100 text-center";
      btn.textContent = text;
      return btn;
    };

    rightCol.appendChild(
      createCustomBtn("ck_accetta_tutti", this.bannerConfiguration.btn.accetta)
    );
    rightCol.appendChild(
      createCustomBtn("ck_customize", this.bannerConfiguration.btn.personalizza)
    );

    let rifiutaBtn = createCustomBtn(
      "ck_close",
      this.bannerConfiguration.btn.rifiuta
    );
    rifiutaBtn.className += " py-2"; // Aggiungi questa classe extra
    rightCol.appendChild(rifiutaBtn);

    // Appendi il ckBanner al body o a un altro elemento del DOM desiderato
    return ckBanner;
  };
  GDPRman.prototype.getBannerCustomizer = function () {
    // Creazione del wrapper principale
    let mainDiv = document.createElement("div");
    mainDiv.className = "p-4";
    mainDiv.id = "cookieCustomizer";

    let modalDialog = document.createElement("div");
    modalDialog.className = "modal-dialog modal-dialog-scrollable modal-lg";
    mainDiv.appendChild(modalDialog);

    let modalContent = document.createElement("div");
    modalContent.className = "modal-content";
    modalDialog.appendChild(modalContent);

    // Creazione dell'header
    let modalHeader = document.createElement("div");
    modalHeader.className = "modal-header";
    modalContent.appendChild(modalHeader);

    let h5 = document.createElement("h5");
    h5.className = "titleLev5 d-none";
    h5.id = "cookieCustomizerModalLabel";
    h5.textContent = this.bannerConfiguration.customizePanel.title; // Imposta il titolo
    modalHeader.appendChild(h5);

    let closeSpan = document.createElement("span");
    closeSpan.id = "ck_cookieCustomizer_close";
    closeSpan.dataset.dismiss = "modal";
    closeSpan.setAttribute("aria-label", "Close");
    modalHeader.appendChild(closeSpan);

    // Creazione del corpo del modal
    let modalBody = document.createElement("div");
    modalBody.className = "modal-body";
    modalContent.appendChild(modalBody);

    let section = document.createElement("section");
    section.className = "textContainer smallParagraph d-none";
    section.innerHTML = this.bannerConfiguration.customizePanel.description; // Imposta la descrizione
    modalBody.appendChild(section);

    let labelContainer = document.createElement("div");
    labelContainer.className = "labelContainer smallParagraph";
    modalBody.appendChild(labelContainer);

    let ul = document.createElement("ul");
    labelContainer.appendChild(ul);

    // Creazione della lista di cookies
    this.bannerConfiguration.consents.forEach((consent) => {
      let li = document.createElement("li");
      ul.appendChild(li);

      let div = document.createElement("div");
      div.className =
        "d-block d-md-flex flex-wrap align-items-center justify-content-between";
      li.appendChild(div);

      let titleSpan = document.createElement("span");
      titleSpan.className = "titleLev4 colorBlack col-12 px-0";
      titleSpan.textContent = consent.title; // Imposta il titolo del cookie
      div.appendChild(titleSpan);

      let p = document.createElement("p");
      p.className = "col-md-11 px-0";
      p.textContent = consent.description; // Imposta la descrizione del cookie
      div.appendChild(p);

      let switcherDiv = document.createElement("div");
      switcherDiv.className = "text-right mt-2 col-md-1 px-0";
      div.appendChild(switcherDiv);

      let switcherInnerDiv = document.createElement("div");
      switcherInnerDiv.className = "switcher";
      switcherDiv.appendChild(switcherInnerDiv);

      let input = document.createElement("input");
      input.id = consent.id; // Imposta l'ID del cookie
      input.type = "checkbox";

      if (consent.checked) input.setAttribute("checked", ""); // Imposta se è checked
      if (consent.disabled) input.setAttribute("disabled", ""); // Imposta se è disabled
      switcherInnerDiv.appendChild(input);

      let label = document.createElement("label");
      label.setAttribute("for", consent.id); // Imposta l'attributo "for" con l'ID del cookie
      switcherInnerDiv.appendChild(label);
    });

    // Creazione del footer del modal
    let footerDiv = document.createElement("div");
    footerDiv.className = "mt-4 text-center";
    modalBody.appendChild(footerDiv);

    let btn = document.createElement("span");
    btn.id = "ck_accetta";
    btn.className = "customBtn style1 mb-3 w-100 text-center";
    btn.textContent = this.bannerConfiguration.btn.accettaCustomizer; // Imposta il testo del bottone
    footerDiv.appendChild(btn);

    // Ritorno l'elemento principale
    return mainDiv;
  };

  GDPRman.prototype.checkCookie = function (name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return true;
    }

    return false;
  };

  GDPRman.prototype.createCookie = function (name, value) {
    const date = new Date();
    date.setMonth(date.getMonth() + 6); // Imposta la scadenza del cookie a 6 mesi da oggi
    const expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + value + expires + "; path=/";
  };

  function extendDefaults(source, properties) {
    var property;
    for (property in properties) {
      if (properties.hasOwnProperty(property)) {
        source[property] = properties[property];
      }
    }
    return source;
  }

  function gets() {
    let scriptURL = "";
    let getsJson = {};

    if (document.getElementById("gdprman") != null) {
      scriptURL = document.getElementById("gdprman").src;
    }

    if (scriptURL != "") {
      let parameters = scriptURL.split("?");
      if (parameters.length > 1) {
        let search = parameters[parameters.length - 1];
        let gets = search.split("&"),
          get = "";
        gets.forEach((elem) => {
          get = elem.split("=");
          getsJson[get[0]] = get.length > 1 ? get[1] : "";
        });
      }
    }

    return getsJson;
  }

  function debb(msg) {
    return;
    //console.log(msg);
  }

  function delete_cookie(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/";
    window.location = "/";
  }

  function rifiuta() {
    let reload = arguments[0] || false;
    // document.getElementById('ck_tecnici').checked = false;
    document.getElementById("ck_statistici").checked = false;
    document.getElementById("ck_marketing").checked = false;
    accetta.call(this, reload);
  }

  function accettaTutti() {
    let reload = arguments[0] || false;
    // document.getElementById('ck_tecnici').checked = true;
    document.getElementById("ck_statistici").checked = true;
    document.getElementById("ck_marketing").checked = true;
    accetta.call(this, reload);
  }

  function accetta() {
    document.getElementById("cookieCustomizer").classList.remove("show");

    let reload = arguments[0] || false;
    if (this.ck_accept == 1 && document.getElementById("ck_banner") == null)
      return;

    var c = new Array();
    let consents = this.getConsents();
    let shopifyConsents = {
      analytics: false,
      marketing: false,
      preferences: false,
      sale_of_data: false,
    };

    if (this.getParameters.hasOwnProperty("mass_accept")) {
      for (let k = 0; k < consents.length; k++) {
        if (consents[k].id == "ck_statistici") {
          shopifyConsents["analytics"] = true;
        }
        if (consents[k].id == "ck_marketing") {
          shopifyConsents["marketing"] = true;
        }
        if (consents[k].id == "ck_necessari") {
          shopifyConsents["preferences"] = true;
        }
        c.push(consents[k].dataIndex);
      }
    } else {
      for (let k = 0; k < consents.length; k++) {
        if (document.getElementById(consents[k].id).checked) {
          if (consents[k].id == "ck_statistici") {
            shopifyConsents["analytics"] = true;
          }
          if (consents[k].id == "ck_marketing") {
            shopifyConsents["marketing"] = true;
          }
          if (consents[k].id == "ck_necessari") {
            shopifyConsents["preferences"] = true;
          }
          c.push(consents[k].dataIndex);
        }
      }
    }

    let _ = this;

    c = c.join(",");

    this.c_status = true;
    document.getElementById("ck_banner").remove();
    document.getElementById("cookieCustomizer").remove();

    window.Shopify.customerPrivacy.setTrackingConsent(
      shopifyConsents,
      function () {
        if (reload) location.reload();
        _.options.callbackAfter();
        _.createCookie("meridiano_consent", "setted");
      }
    );

    // activate_elements.call(this);
  }

  function getCookie(name) {
    var dc = document.cookie;
    var prefix = name + "=";
    //var begin = dc.indexOf("; " + prefix);
    var begin = dc.indexOf(prefix);
    if (begin == -1) {
      begin = dc.indexOf(prefix);
      if (begin != 0) return "";
    } else {
      //begin += 2;
      var end = document.cookie.indexOf(";", begin);
      if (end == -1) {
        end = dc.length;
      }
    }
    debb("START: " + begin + " END: " + end);
    cookie = decodeURI(dc.substring(begin + prefix.length, end));

    if (cookie != "") {
      cookie = cookie.split(",");
    } else {
      cookie = null;
    }
    return cookie;
  }
})();
